export const TRANSFERDETAIL_LOADING = "TRANSFERDETAIL_LOADING";
export const TRANSFERDETAIL_RESET = "TRANSFERDETAIL_RESET";
export const GET_TRANSFERDETAIL = "GET_TRANSFERDETAIL";
export const GET_TRANSFERDETAIL_SUCCESS = "GET_TRANSFERDETAIL_SUCCESS";
export const GET_TRANSFERDETAIL_FAIL = "GET_TRANSFERDETAIL_FAIL";
export const DELETE_TRANSFERDETAIL = "DELETE_TRANSFERDETAIL"
export const DELETE_TRANSFERDETAIL_SUCCESS = "DELETE_TRANSFERDETAIL_SUCCESS"
export const DELETE_TRANSFERDETAIL_FAIL = "DELETE_TRANSFERDETAIL_FAIL"
export const UPDATE_TRANSFERDETAIL = "UPDATE_TRANSFERDETAIL"
export const UPDATE_TRANSFERDETAIL_SUCCESS = "UPDATE_TRANSFERDETAIL_SUCCESS"
export const UPDATE_TRANSFERDETAIL_FAIL = "UPDATE_TRANSFERDETAIL_FAIL"
export const ADD_NEW_TRANSFERDETAIL = "ADD_NEW_TRANSFERDETAIL"
export const ADD_TRANSFERDETAIL_SUCCESS = "ADD_TRANSFERDETAIL_SUCCESS"
export const ADD_TRANSFERDETAIL_FAIL = "ADD_TRANSFERDETAIL_FAIL"